
import DrawBase from "./DrawBase"

import EditPolygon from "./EditPolygon"

class DrawPolygon extends DrawBase {
    constructor(options) {
        super(options);
        this.options = options;
        this.style=undefined;
    }

    //左键
    leftClick(evt) {
        var $this = this;
        var position = this.getCatesian3FromPX(evt.position);
        if ($this.positions.length == 0) {
            $this.positions.push(position.clone());
        }
        $this.positions.push(position);
    }

    mouseMove(evt) {
        var $this = this;
        if ($this.positions.length < 1) return;
        var cartesian = $this.getCatesian3FromPX(evt.endPosition);

        if ($this.positions.length == 3) {
            if (!$this.Cesium.defined($this.plot)) {
                $this.plot = $this.createPolygon($this.positions,this.style);
                $this.entities.push($this.plot);
                $this.initEditor();
            }
        }
        $this.positions.pop();
        $this.positions.push(cartesian);
    }

    initEditor() {
        var $this = this;
        $this.editHelp = new EditPolygon(this.options); //初始化编辑类
    }
}

export default DrawPolygon;